module.exports = __webpack_public_path__ + "img/logot.971b02f5.svg";